import { createFileRoute } from "@tanstack/react-router";

import { PraxaUsageSurface } from "../components/praxa/PraxaUsageSurface";

export const Route = createFileRoute("/w/$workspaceId/usage")({
  component: PraxaUsageSurface,
});
